export enum STRUCTURED_CONTENT {
    /**
     * @value For accessibility purpose, expand the rich text area.
     */
    WARNING_MESSAGE_SMALL_DISPLAY = 'STRUCTURED_CONTENT.WARNING_MESSAGE_SMALL_DISPLAY',
}
